module.exports = __webpack_public_path__ + "static/simufact06-187d87814b498466be9c41afbd3439d0.png";